import { LinearGradient } from "expo-linear-gradient";
import React from 'react';
import { Clipboard, Text, TouchableOpacity, View } from 'react-native';
import { FormattedMessage, useIntl } from 'react-intl';

import HeaderDefault from '../../components/HeaderDefault';
import { toast } from '../../utils/toast';

import styles from './styles';

const BankSlip = () => {
    function copyBarCode(barCode) {
        Clipboard.setString(barCode);
        const intl = useIntl();
        toast(intl.formatMessage({id:'bankSlip.msgCopiadoAreaTransferencia'}), "green");
    }

    return (
        <>
            <HeaderDefault title={<FormattedMessage id="bankSlip.headerBoletoBancario"/>} />

            <View style={styles.container}>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}><FormattedMessage id="bankSlip.txtValorBoleto"/></Text>
                    <Text><FormattedMessage id="bankSlip.txtValorBrl"/></Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}><FormattedMessage id="bankSlip.txtValidade"/></Text>
                    <Text><FormattedMessage id="bankSlip.txtData"/></Text>
                </View>

                <View style={styles.hr} />

                <Text style={styles.textInfoPayment}><FormattedMessage id="bankSlip.txtReconhecimentoPagmtDemorar"/>
                     <Text style={{ fontWeight: 'bold' }}><FormattedMessage id="bankSlip.txtAte2DiasUteis"/></Text>
                </Text>

                <Text style={styles.infoNumberBankSplip}><FormattedMessage id="bankSlip.txtUtilizeCodigoBarras"/>
                </Text>

                <Text style={styles.barCode}><FormattedMessage id="bankSlip.txtCodigoBarra"/></Text>
            </View>

            <TouchableOpacity style={styles.contentSendEmail}>
                <Text style={styles.textSendEmail}><FormattedMessage id="bankSlip.txtEnviarPorEmail"/></Text>
            </TouchableOpacity>

            <View style={styles.contentBtn}>
                <TouchableOpacity onPress={() => copyBarCode('00000.00000 00000.000000 00000.000000 0 000000000000000')}>
                    <LinearGradient
                        start={{ x: -1, y: 0 }}
                        end={{ x: 1, y: 0 }}
                        colors={["#196059", "#196059"]}
                        style={styles.btn}
                    >
                        <Text style={styles.textBtn}><FormattedMessage id="bankSlip.btnCopiarCodio"/></Text>
                    </LinearGradient>
                </TouchableOpacity>
            </View>
        </>
    );
}

export default BankSlip;